import { logger as LOG } from '@garnish/logger';

// ─── Logger ──────────────────────────────────────────────────────────────────

export const logger = LOG.extend('AUTH STATE MACHINE');
